import { Box, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ProfileSection from './ProfileSection';
import LogoSection from '../LogoSection';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';

interface HeaderProps {
  handleDrawerOpen: () => void;
  open?: boolean;
}

const Header: React.FC<HeaderProps> = ({ handleDrawerOpen, open }: HeaderProps) => {
  return (
    <>
      <IconButton
        color="inherit"
        aria-label="open drawer"
        onClick={handleDrawerOpen}
        edge="start"
        sx={{
          marginRight: 3,
          // ...(open && { display: 'none' })
        }}
      >
        
        {!open ? <MenuOpenIcon /> : <MenuIcon />}
      </IconButton>
      {/* {!open ? <LogoSection /> : null} */}
      <LogoSection />

      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />
      <ProfileSection />
    </>
  );
};

export default Header;
